import AuditTrailTemplate from "components/lib/Shared/AuditTrailTemplate";
import { useSelector } from "react-redux";

const IncorporationAuditTrail = () => {
  const { company } = useSelector((state) => state.companySlice);
  const { envelopes } = company;

  return (
    <div>
      <AuditTrailTemplate envelopes={envelopes} />
    </div>
  );
};

export default IncorporationAuditTrail;
